import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=2a8f0d63&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"
import style0 from "./InfoView.vue?vue&type=style&index=0&id=2a8f0d63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f0d63",
  null
  
)

export default component.exports